export default import.meta.ROLLUP_FILE_URL_ZoP2ebLT5e$hm8jPkF9mgA;